import React from 'react';
import DeleteIcon from 'material-ui-icons/Delete';
import PreviewIcon from 'material-ui-icons/Visibility';
import CompareIcon from 'material-ui-icons/CompareArrows';
import CurrentActiveIcon from 'material-ui-icons/CheckCircle';
import NotActiveIcon from 'material-ui-icons/Block';
import {
    showDeleteRevisionButton,
    showViewRevisionContentButton
} from '../../../components/permissions/permissions';
import {
    TableCell,
    TableRow,
    Tooltip,
    IconButton
} from 'material-ui';
import {getFilteredDataById} from '../../../components/helpers/helpers'

class PageVersionsTableContent extends React.Component {

    render() {
        const {
            classes,
            pageId,
            page,
            version,
            handleOpenDelete,
            openViewPageVersionPopup,
            fetchPageVersion
        } = this.props;

        let CompareVersionButton = showViewRevisionContentButton(() =>
            <span>
                {version.is_current !== true ? 
                <Tooltip title="Compare this version with the active version">
                    <IconButton
                        className="smallIconButton editColor"
                        onClick={() => {
                            openViewPageVersionPopup(pageId);
                            fetchPageVersion(version.id);
                        }}
                    >
                        <CompareIcon />
                    </IconButton>
                </Tooltip>
                : 'No actions available on the active version'}
            </span>
        )

        let PreviewVersionButton = showViewRevisionContentButton(() =>
            <span>
                <Tooltip title="Preview content on the website">
                    <IconButton
                        className="smallIconButton viewColor"
                        onClick={() => {
                            window.open(getFilteredDataById(page.versions, version.id).preview_url)
                        }}
                    >
                        <PreviewIcon />
                    </IconButton>
                </Tooltip>
            </span>
        )

        let DeleteVersionButton = showDeleteRevisionButton(() =>
            <span>
                <Tooltip title="Delete Version">
                    <IconButton
                        className="smallIconButton deleteColor"
                        onClick={e => handleOpenDelete(version.id)}
                    >
                        <DeleteIcon />
                    </IconButton>
                </Tooltip>
            </span>
        )

        return (
            <TableRow hover={true}>
                <TableCell>{version.id}</TableCell>
                <TableCell>{version.version}</TableCell>
                <TableCell>
                    {version.is_current === true ? 
                        <CurrentActiveIcon className={classes.enabledCheckbox}/>
                    :
                        <NotActiveIcon className={classes.disabledCheckbox}/>
                    }
                </TableCell>
                <TableCell>
                    {version.is_current !== true && [
                        <CompareVersionButton key={0}/>,
                        <DeleteVersionButton key={1}/>
                    ]}
                    <PreviewVersionButton />
                </TableCell>
            </TableRow>
        )
    }
}

export default PageVersionsTableContent;


// WEBPACK FOOTER //
// ./src/containers/builder/versions/PageVersionsTableContent.jsx